export enum FeatureFlag {
  AsapDriverBreaks = 'asapDriverBreaks',
  Promos = 'promos',
  DisableDriverAppFlagDown = 'disableDriverAppFlagDown',
  AllowMatchingConfiguration = 'allowMatchingConfiguration',
  FarePasses = 'farePasses',
  VoiceNotifications = 'voiceNotifications',
  UseDriverAppBearing = 'useDriverAppBearing',
  DriverInAppCalling = 'driverInAppCalling',
  DemandForecasting = 'demandForecasting',
  DisableNavigationIos = 'disableNavigationIos',
  DisableNavigationAndroid = 'disableNavigationAndroid',
  DisplayDriveUntilMessaging = 'displayDriveUntilMessaging',
  EngageAIScan = 'engageAIScan',
  DisableRiderOnboarding = 'disableRiderOnboarding',
  FareRules = 'fareRules',
  TipPolicies = 'tipPolicies',
  Routes = 'routes',
  ShowAllSlotsToDriver = 'showAllSlotsToDriver',
  Multimodal = 'multimodal',
  ExcludeWalkingTimeInDesiredTs = 'excludeWalkingTimeInDesiredTs',
  RequestInsights = 'requestInsights',
  AllowBookingWithoutPaymentMethod = 'allowBookingWithoutPaymentMethod',
  DriverTripHistory = 'driverTripHistory',
  DisableEditingAddingVehicle = 'disableEditingAddingVehicle',
  EngineV2GlobalOptimization = 'engineV2GlobalOptimization',
  OpenFleet = 'openFleet',
  StripeCustomerDetails = 'stripeCustomerDetails',
  MergeZonesOnLiveMap = 'mergeZonesOnLiveMap',
  MergeZonesOnServicesPage = 'mergeZonesOnServicesPage',
  MergeZonesOnDutyTimeTravel = 'mergeZonesOnDutyTimeTravel',
  MergeZonesServerSide = 'mergeZonesServerSide',
  ConstraintOverrides = 'constraintOverrides',
  LiveGlobalOptimization = 'liveGlobalOptimization',
  LyftPromotion = 'lyftPromotion',
  MultimodalTransitHubs = 'multimodalTransitHubs',
  DriverBreaks = 'driverBreaks',
  DutyInterruptionReasons = 'dutyInterruptionReasons',
  AutoCompleteOnlyWhenAtEndLocation = 'autoCompleteOnlyWhenAtEndLocation',
  LyftPassLink = 'lyftPassLink',
  ReportTemplate = 'reportTemplate',
  LockToDuty = 'lockToDuty',
  InAppTesting = 'inAppTesting',
  EtaChangedNotifications = 'etaChangedNotifications',
  CapMetroCustomRoles = 'capMetroCustomRoles',
  CustomRoles = 'customRoles',
  CompleteActivityLog = 'completeActivityLog',
  FixedRouteTravelDuration = 'fixedRouteTravelDuration',
  DriverRiderReviews = 'driverRiderReviews',
  Announcements = 'announcements',
  OrganizationPrivacyConfigurations = 'organizationPrivacyConfigurations',
  SMSRiderNotifications = 'smsRiderNotifications',
  WalkingDirections = 'walkingDirections',
  RecurringTrips = 'recurringTrips',
  OperationsCaseCreation = 'operationsCaseCreation',
  OptimizationInsights = 'optimizationInsights',
  SmsEta = 'smsEta',
  SmsCancelRide = 'smsCancelRide',
  PhoneIvrEta = 'PhoneIvrEta',
  PhoneIvrBookRide = 'PhoneIvrBookRide',
  PhoneIvrCancelRide = 'PhoneIvrCancelRide',
  ManuallyTriggeredOptimization = 'manuallyTriggeredOptimization',
  BulkMessages = 'bulkMessages',
  FixedRouteAlternativesInLaunch = 'fixedRouteAlternativesInLaunch',
  LanguageAndChannelPreferences = 'languageAndChannelPreferences',
  CapMetroGroupExpiryNotifications = 'capMetroGroupExpiryNotifications',
  RenameAccessibilityFeatures = 'renameAccessibilityFeatures',
  RenameAccessibilityFeaturesMBTA = 'renameAccessibilityFeaturesMBTA',
  MoreFrequentOptimization = 'moreFrequentOptimization',
  CallForVerificationCode = 'callForVerificationCode',
  IvrCallRecording = 'ivrCallRecording',
  LiveTraffic = 'liveTraffic',
  LocationNotes = 'locationNotes',
  DriverDispatchCommunication = 'driverDispatchCommunication',
  DutyDelays = 'dutyDelays',
  DriverIdleMap = 'driverIdleMap',
  EngageCasesOnRider = 'engageCasesOnRider',
  DriverShowRiderFullName = 'driverShowRiderFullName',
  DisableRiderAppPhotoEditing = 'disableRiderAppPhotoEditing',
  SchedulingBeforeEstimates = 'schedulingBeforeEstimates',
  ForceMatch = 'forceMatch',
  UnscheduledDriving = 'unscheduledDriving',
  AcceptRejectFleet = 'acceptRejectFleet',
  EnableRiderAppMixpanelAnalytics = 'enableRiderAppMixpanelAnalytics',
  DisableUpdatingDefaultProfileFields = 'disableUpdatingDefaultProfileFields',
  MetabaseReports = 'metabaseReports',
  ConditionalEligibility = 'conditionalEligibility',
  DataReconciliation = 'dataReconciliation',
  ManualInterventions = 'manualInterventions',
  MergeZonesOnRider = 'mergeZonesOnRider',
  DisplayZonesOnRider = 'displayZonesOnRider',
  DutyPulloutVisibility = 'dutyPulloutVisibility',
  DisablePleoLiveMessage = 'disablePleoLiveMessage',
  DisablePleoManualInterventions = 'disablePleoManualInterventions',
  ValidatePickupAndDropoffLocationsRider = 'validatePickupAndDropoffLocationsRider',
  VehicleClass = 'vehicleClass',
  RiderPhonePin = 'riderPhonePin',
  LaunchAIVoice = 'launchAIVoice',
  EngageAIVoice = 'engageAIVoice',
  Wallet = 'wallet',
  VehicleInspections = 'vehicleInspections',
  RiderZoneRestrictionByGroups = 'riderZoneRestrictionByGroups',
  HideStopDescriptionsOnRiderTimeline = 'hideStopDescriptionsOnRiderTimeline',
  LiveRequest = 'liveRequest',
  DisableLocationNotesInRiderApp = 'disableLocationNotesInRiderApp',
  DataRetention = 'dataRetention',
  BookingCopilot = 'bookingCopilot',
  OrganizationSwitcherPopover = 'organizationSwitcherPopover',
  ViewDriverKpis = 'viewDriverKpis',
  CustomCancellationReasons = 'customCancellationReasons',
  DisableConditionalEligibilityBanner = 'disableConditionalEligibilityBanner',
  EnableRiderAppDriverPolyline = 'enableRiderAppDriverPolyline',
  AnalyzeCopilot = 'analyzeCopilot',
  DutyLatenessByBins = 'dutyLatenessByBins',
  AllowIncompleteForms = 'allowIncompleteForms',
  Tickets = 'tickets',
  LatenessThresholdOneMinute = 'latenessThresholdOneMinute',
  MultipleWorkflows = 'multipleWorkflows',
  RiderNewScheduleTripFlow = 'riderNewScheduleTripFlow',
  RiderNewScheduleButton = 'riderNewScheduleButton',
  ZoneStopLibrary = 'zoneStopLibrary',
  TestNewLoadBalancer = 'testNewLoadBalancer',
  EngageActivityFeed = 'engageActivityFeed',
  ShowTargetedOptimization = 'showTargetedOptimization',
  EngageCaseViewV2Peek = 'engageCaseViewV2Peek',
  DutySchedulePlusPlus = 'dutySchedulePlusPlus',
  DutySchedulePlusPlusDetails = 'dutySchedulePlusPlusDetails',
  DutyScheduleRequestsEndpoint = 'dutyScheduleRequestsEndpoint',
  LiveMessagesNotificationSound = 'liveMessagesNotificationSound',
  FleetArea = 'fleetArea',
  RiderRepresentatives = 'riderRepresentatives',
  RestrictedArea = 'restrictedArea',
  TransactionGrouping = 'transactionGrouping',
  DutyActivityFeed = 'dutyActivityFeed',
  RequestActivityFeed = 'requestActivityFeed',
  IncidentReporting = 'incidentReporting',
  RecurringTripsInRider = 'recurringTripsInRider',
  AddRecurringTripFromRequestV2 = 'addRecurringTripFromRequestV2',
  FixedRouteEquivalentDetour = 'fixedRouteEquivalentDetour',
  RiderViewPeek = 'riderViewPeek',
  TotalRevenueHoursV2 = 'totalRevenueHoursV2',
  AiChat = 'aiChat',
  ShowAllStopsInSearchList = 'showAllStopsInSearchList',
  ReduceRiderEstimatePollingRate = 'reduceRiderEstimatePollingRate',
  PublishDispatchingEvents = 'publishDispatchingEvents',
  ShowDispatchingEvents = 'showDispatchingEvents',
  OnDemandRideOptionCardDesignV2 = 'onDemandRideOptionCardDesignV2',
  CubeAnalytics = 'cubeAnalytics',
  AnalyticsV2 = 'analyticsV2',
  LiveGlobalOptimizationExtendedRuntime = 'liveGlobalOptimizationExtendedRuntime',
  OsrmTableElementCaching = 'osrmTableElementCaching',
  GoogleRoutingTesting = 'googleRoutingTesting',
  BreaksWithLocations = 'breaksWithLocations',
  SpareAiChatL2 = 'spareAiChatL2',
  RequireBreaksWithLocationsToBeStartedManually = 'requireBreaksWithLocationsToBeStartedManually',
  CaseSummary = 'caseSummary',
  LaMetroHardcodedRiderDescriptions = 'laMetroHardcodedRiderDescriptions',
  AiVoiceAddPaymentMethod = 'aiVoiceAddPaymentMethod',
  UseNavigationService = 'useNavigationService',
  HideAlternativeTripTimes = 'hideAlternativeTripTimes',
  DARTDetourFlexibilityExperiment = 'dartDetourFlexibilityExperiment',
  DriverAppRouteDistanceOnly = 'driverRouteDistanceOnly',
  PermissionBasedSidebarProductVisibility = 'permissionBasedSidebarProductVisibility',
  ConditionalForms = 'conditionalForms',
  EngageRiderHub = 'engageRiderHub',
  LiveMapAlerts = 'liveMapAlerts',
  OpenFleetRematching = 'openFleetRematching',
  AuditLogs = 'auditLogs',
  DirectorySync = 'directorySync',
  TripGroup = 'tripGroup',
  TelecomsV2 = 'telecomsV2',
  PhoneNumberWebhookMigration = 'phoneNumberWebhookMigration',
  RequestTimeline = 'requestTimeline',
  DetourConfigV2 = 'detourConfigV2',
  GoogleMapsOnDriverApp = 'googleMapsOnDriverApp',
  EdiEligibility = 'ediEligibility',
  AnalyticsAboveLaunchAndEngage = 'analyticsAboveLaunchAndEngage',
  ShallowSearchAllWindows = 'shallowSearchAllWindows',
  AiVoicePhoneNumberWithIdAndPinFallback = 'aiVoicePhoneNumberWithIdAndPinFallback',
  AiVoiceFixedRouteEta = 'aiVoiceFixedRouteEta',
  DisableDriverOfflineScreen = 'disableDriverOfflineScreen',
  SensitiveDataField = 'sensitiveDataField',
  MbtaTestOrgSftp = 'mbtaTestOrgSftp',
  MbtaProdOrgSftp = 'mbtaProdOrgSftp',
  HideEmptyAppointmentLocation = 'hideEmptyAppointmentLocation',
  QuickReplies = 'quickReplies',
  ExperimentalMapStyles = 'experimentalMapStyles',
  GoogleTranslate = 'googleTranslate',
  RiderEmailAuthentication = 'riderEmailAuthentication',
  DriverBehavioursInDriverApp = 'driverBehavioursInDriverApp',
  WatchlistAlertActions = 'watchlistAlertActions',
  ImprovedNegotiationUi = 'improvedNegotiationUi',
  GoogleMapsPerTripBilling = 'googleMapsPerTripBilling',
  AiInWorkflows = 'aiInWorkflows',
  RbacProviderUi = 'rbacProviderUi',
  EnableSlotCompleteInVehicleStatus = 'enableSlotCompleteInVehicleStatus',
  FixedRouteAntiCannibalization = 'fixedRouteAntiCannibalization',
  RiderGtfsScheduleViewer = 'riderGtfsScheduleViewer',
  DutyCancellationReasons = 'dutyCancellationReasons',
  AddressV2 = 'addressV2',
  SafeDurationFromService = 'safeDurationFromService',
  VisitorConditions = 'visitorConditions',
  EnableGBFSTripPlanning = 'enableGBFSTripPlanning',
  DARTCrossFleetOptimization = 'dartCrossFleetOptimization',
  ReadOnlyExternalRiderIds = 'readOnlyExternalRiderIds',
  StartEndTimeForAnnouncements = 'startEndTimeForForAnnouncements',
  UseDynamicCubes = 'useDynamicCubes',
  UpcomingStopsVisibility = 'upcomingStopsVisibility',
  GroupRidersSingleRequest = 'groupRidersSingleRequest',
  CustomFieldOtherOptionWithFreeText = 'customFieldOtherOptionWithFreeText',
  PromptToCancelReturnTrip = 'promptToCancelReturnTrip',
  EngageCaseObjectLinks = 'engageCaseObjectLinks',
  DisableDriverControlSoundNotifications = 'disableDriverControlSoundNotifications',
  LogDenials = 'logDenials',
}
